<template>
  <DashboardBlock title="Рабочие смены">
    <template slot="content">
      <div class="content__calendar">
        <Preloader v-if="isLoading" type="small" />
        <div
          v-if="!hasWorkShiftToday && !isLoading"
          class="calendar__notice_without-shift"
        >
          <span>Сегодня у вас нет смены</span>
        </div>
        <ShiftsCalendar
          v-if="!isLoading"
          :dates="calendarDates"
          :times="times"
          class="calendar"
        />
      </div>
    </template>
  </DashboardBlock>
</template>

<script>
import DashboardBlock from '@/_shared/components/ui/DashboardBlock';
import ShiftsCalendar from '@/_shared/features/work-shift-menu/ShiftsCalendar';
import Preloader from '@/_shared/components/ui/Preloader';
import { workShiftService } from "@/_shared/api-services";
import { useDatesHelper } from '@/_shared/mixins/work-shift-menu';
export default {
  mixins: [useDatesHelper],
  components: {
    ShiftsCalendar,
    DashboardBlock,
    Preloader,
  },
  data() {
    return {
      isLoading: false,
      calendarDates: [],
      times: {},
    };
  },
  async created() {
    this.isLoading = true;
    await workShiftService.get().then(({ data }) => {
      if (data.calendar !== null) {
        this.calendarDates = JSON.parse(data.calendar.dates);
        this.times = JSON.parse(data.calendar.times);
      }
      this.isLoading = false;
    });
  },
};
</script>

<style scoped>
.content__calendar {
  padding-top: 14px;
}
.content__calendar > .calendar {
  min-height: 250px;
  align-items: center;
  justify-content: center;
}
.calendar__notice_without-shift {
  font-size: 1.1em;
  padding-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/user/components/personal-area/WorkShiftsBlock.vue